import { type UseMutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mantangApi as api } from '@/shared/api';
import { MESSAGE } from '@/shared/consts';
import { carKeys } from './car.keys';

type UpsertCarInfo = Required<
	Pick<
		Parameters<typeof api.upsertUserCarInfo>[0],
		'model_id' | 'model' | 'type' | 'efficiency'
	>
> &
	Partial<
		Pick<Parameters<typeof api.upsertUserCarInfo>[0], 'average_fuel_amount'>
	>;

export const upsertUserCarInfoMutationOptions = (): UseMutationOptions<
	void,
	Error,
	UpsertCarInfo
> => ({
	mutationFn: async (carInfo) => {
		await api.upsertUserCarInfo(carInfo);
	},
	onError: () => {
		toast.error(MESSAGE.ERROR.RETRY);
	},
	onSettled: (_, __, ___, ____, context) => {
		context.client.invalidateQueries({ queryKey: carKeys.userCarInfo() });
	},
});

export const deleteUserCarInfoMutationOptions = (): UseMutationOptions<
	void,
	Error,
	void
> => ({
	mutationFn: async () => {
		await api.deleteUserCarInfo();
	},
	onError: () => {
		toast.error(MESSAGE.ERROR.RETRY);
	},
	onSettled: (_, __, ___, ____, context) => {
		context.client.invalidateQueries({ queryKey: carKeys.userCarInfo() });
	},
});
